export const LISTE_ORDRE_TRAVAIL_TECH = {
  title: 'Ordres de travail - Technique',
  breadcrumb: {
    ordresTravails: 'Ordres de travail',
  },
  actions: {
    add: 'Nouvel OT',
    editionMasse: 'Générer les éditions',
    annuler: 'Annuler',
    realise: 'Réaliser',
    enAttente: 'En attente',
    enCours: 'En cours',
    planifie: 'Planifier',
    cloturer: 'Clôturer',
    aExpedier: 'A expédier',
    expedie: 'Expédier',
    bonLivraison: 'Édition BL',
  },
  etat: {
    enAttente: 'En attente',
    enCours: 'En cours',
    annule: 'Annulé',
    realise: 'Réalisé',
    planifie: 'Planifié',
    cloture: 'Clôturé',
    aExpedier: 'A expédier',
    expedie: 'Expédié',
  },
  tabs: {
    code: 'N° ordre de travail',
    type: 'Type',
    etat: 'Etat',
    dateSouhaite: 'Date souhaitée',
    datePlanification: 'Date de planification',
    dateRealisation: 'Date de réalisation',
    dateFacture: 'Date facture',
    codeFacture: 'Code facture',
    technicien: 'Technicien',
    montantHt: 'Montant HT',
    patrimoine: 'Patrimoine',
    adresse: 'Adresse',
    ville: 'Ville',
    codePostal: 'Code postal',
    progression: 'Progression',
    agence: 'Agence',
    projet: 'Projet',
    dossier: 'Dossier',
    typeEmplacement: ' (emplacement)',
    typeMateriel: ' (matériel)',
    typeDispositif: ' (dispositif)',
    typeFace: ' (face)',
    description: 'Description',
    createBy: 'Créé(e) par',
  },
  filtre: {
    code: 'Code(s)',
    type: 'Type(s)',
    etat: 'Etat(s)',
    agence: 'Agence(s)',
    dateFacture: 'Date facture',
    codeFacture: 'Code(s) facture',
    dateSouhaite: 'Date souhaitée',
    datePlanification: 'Date de planification',
    dateRealisation: 'Date de réalisation',
    technicien: 'Technicien(s)',
    projet: 'Projet(s)',
    dossier: 'Dossier(s)',
    ville: 'Ville(s)',
    codePostal: 'Code(s) postal',
    adresse: 'Adresse',
    face: 'Face : {face}',
    facture: 'Facturé',
    error: {
      dates: 'La date de début du filtre par date souhaitée est plus grande que sa date de fin',
      datesPremierAffichage: 'La date de début du filtre par date de planification est plus grande que sa date de fin',
      datesValidite: 'La date de début du filtre par date de réalisation est plus grande que sa date de fin',
      datesFacture: 'La date de début du filtre par date de facture est plus grande que sa date de fin',
    },
  },
  annulerOt: 'Êtes-vous sûr de vouloir annuler vos ordres de travail ?',
  realiserOt: 'Êtes-vous sûr de vouloir réaliser vos ordres de travail ?',
  planifierOt: 'Êtes-vous sûr de vouloir planifer vos ordres de travail ?',
  cloturerOt: 'Êtes-vous sûr de vouloir clôturer vos ordres de travail ?',
  enCoursOt: 'Êtes-vous sûr de vouloir mettre à l\'état "en cours" vos ordres de travail ?',
  enAttenteOt: 'Êtes-vous sûr de vouloir mettre à l\'état "en attente" vos ordres de travail ?',
  aExpedierOt: 'Êtes-vous sûr de vouloir mettre à l\'état "à expédier" vos ordres de travail ?',
  expedierOt: 'Êtes-vous sûr de vouloir mettre à l\'état "expédié" vos ordres de travail ?',
  actionIntervationTypeOt: 'Effectuer les actions d\'intervention sur le patrimoine lié',
  actionImpactEtatDemande: 'Passer à l\'état "Traité" les demandes liées',
  actionAnnulationImpactEtatDemande: 'Passer à l\'état "Refusé" les demandes liées',
  popUpSuppression: {
    title: 'Etes-vous sûr de vouloir supprimer cet ordre de travail ?',
    monter: 'Passer à l\'état "Monter" le patrimoine lié ?',
    demonter: 'Passer à l\'état "Démonter" le patrimoine lié ?',
    aMonterADemonter: 'Passer à l\'état "A monter"/"A démonter" le patrimoine lié ?',
  },
  messages: {
    success: {
      otDelete: 'Ordre de travail technique supprimé avec succès',
    },
    error: {
      otNeedDatePlanifMulti: 'Pour passer à l\'état "Planifié", les OT technique {code} doivent avoir une date de planification renseignée',
      otNeedDateRealisationMulti: 'Pour passer à l\'état "Réalisé", les OT technique {code} doivent avoir une date de réalisée renseignée',
      otNeedDatePlanif: 'Pour passer à l\'état "Planifié", l\'OT technique {code} doit avoir une date de planification renseignée',
      otNeedDateRealisation: 'Pour passer à l\'état "Réalisé", l\'OT technique {code} doit avoir une date de réalisée renseignée',
    },
  },
};

export const ADD_ORDRE_TRAVAIL_TECH = {
  title: {
    add: 'Ajouter un ordre de travail technique',
    edit: 'Modifier l\'ordre de travail technique: {code}',
  },
  titleImpression: {
    add: 'Ajouter un ot impression',
    edit: 'Modifier l\'ot impression: {code}',
  },
  breadcrumb: {
    liste: 'Ordres de travail',
    add: 'Ajouter ordre travail technique',
    edit: 'Modifier ordre travail technique',
  },
  onglet: {
    caracterique: 'Caractéristiques',
    patrimoine: 'Patrimoine',
    demande: 'Demande(s) liée(s)',
    bilan: 'Bilan intervention',
    adresseLivraison: 'Adresse de livraison',
    lieuDeLivraison: 'Adresse de livraison si différente',
  },
  caracterique: {
    infoGenerale: {
      title: 'Informations générales',
      dateSouhaite: 'Date souhaitée',
      datePlanification: 'Date de planification',
      dateRealisation: 'Date de réalisation',
      typeIntervention: 'Type d\'intervention',
      technicien: 'Technicien',
      montantHT: 'Montant HT',
      dossierAssocie: 'Dossier associé',
      description: 'Description',
      agence: 'Agence',
      dateFacture: 'Date facture',
      codeFacture: 'Code facture',
      lieuDeStockage: 'Lieu de stockage',
      quantite: 'Quantite',
      tags: 'Tag(s)',
      tagInfo: 'Si le tag n\'existe pas il sera créé en validant l\'entrée.',
    },
    tache: {
      title: 'Liste des tâches',
      taches: '{tacheRealise} / {tacheTotal} tâche(s)',
      noTache: 'Aucune tâche ajoutée',
      realise: 'Réalisée',
      libelle: 'Titre',
      description: 'Description',
      action: {
        add: 'Ajouter une tâche',
      },
    },
  },
  patrimoine: {
    noPat: {
      title: 'Aucun patrimoine sélectionné',
      associe: 'Associer un patrimoine à mon OT',
      warTitle: 'Sélectionner votre lieu de stockage',
      warnNoSelectPat: `Attention, il est fortement conseillé de sélectionner votre lieu de
        stockage avant de faire la sélection du patrimoine. Cela permet de filtrer
        celui-ci en fonction du client sélectionné.`,
    },
    emplacement: {
      title: 'Emplacement : {code}',
      champs: {
        title: 'Emplacement',
        natureSol: 'Nature de sol',
        codeBarre: 'Code barre',
        degreDeniveleTerrain: 'Degré de dénivelé du terrain',
        accesSiteSurRdv: 'Accès au site sur RDV',
        acces: 'Accès',
        groupeDhabitation: 'Groupe d\'habitation',
        numUg: 'N° UG',
        quartier: 'Quartier ',
        client: 'Client',
      },
    },
    dispositif: {
      title: 'Dispositif : {code}',
      type: 'Type dispositif : ',
      support: 'Dispositif support : ',
      adresse: 'Adresse',
      etat: 'Etat dispositif :',
      champs: {
        title: 'Dispositif',
        couleurRal: 'Couleur RAL',
        restrictionsAffichage: 'Restrictions d\'affichage',
        valeurAcquisition: 'Valeur d\'acquisition',
        longueur: 'Longueur',
        publicitaire: 'Publicitaire',
        particularite: 'Particularité',
        largeurToit: 'Largeur toit',
        eclairable: 'Eclairable',
        planRecollement: 'Plan recollement',
        cableEdfProx: 'Câble EDF à proximité',
        distanceEnMCablesEdf: 'Distance en mètres des câbles EDF',
        hauteurSousPanneau: 'Hauteur sous panneau',
        iOT: 'IOT',
        commentaire: 'Commentaire',
        code: 'Code',
        name: 'Nom',
        pDLElectricite: 'PDL électricité',
        recollement: 'Recollement',
        nacelleNecessaire: 'Nacelle nécessaire',
        grueNecessaire: 'Grue nécessaire',
        echelleNecessaire: 'Echelle nécessaire',
        autreEquipementNecessaire: 'Autre équipement nécessaire',
        obstacle: 'Obstacle',
        declararionPrealable: 'Déclaration préalable',
        fournisseurElectricite: 'Fournisseur éléctricité',
        tiersProprietaire: 'Tiers propriétaire',
        accessoires: {
          title: 'Liste des accessoires',
          libelle: 'Accessoire',
          quantite: 'Quantité',
          add: 'Ajouter un accessoire',
        },
      },
    },
    materiel: {
      title: 'Matériel : {code}',
      type: 'Type matériel: ',
      format: 'Format matériel : ',
      champs: {
        title: 'Matériel',
        passerelle: 'Passerelle',
        typeEclairage: 'Type d\'éclairage',
        longueur: 'Longueur (cm)',
        largeur: 'Largeur (cm)',
      },
    },
    face: {
      title: 'Face : {code}',
    },
    addPatToOt: {
      title: 'Ajouter un patrimoine à votre ordre de travail technique',
      breadcrumb: {
        add: 'Ajout patrimoine à OT',
      },
    },
    addDemandeToOt: {
      title: 'Lier une demande à votre ordre de travail technique',
      breadcrumb: {
        add: 'Lier demande à OT',
      },
    },
    canNotChangePatrionine: 'Impossible de changer le patrimoine car l\'ordre de travail est de type "Fabrication du dispositif" ou "Pose du dispositif fabriqué"',
    clientNotOwner: 'Le patrimoine sélectionné ne correspondant pas au lieu de stockage',
    hasToBeDispositif: 'Un ot d\'impression ne peut avoir qu\'un dispositif en tant que patrimoine',
    etatAExpedierNotAllowed: 'L\'état "A expedier" n\'est pas autorisé sur une des OTs',
    moduleImpressionNotActivated: 'Le module Demande d\'Impression n\'est pas activé',
  },
  demandeLiee: {
    noDemande: {
      title: 'Aucune demande liée',
      associe: 'Lier une demande à mon OT',
    },
    actions: {
      lie: 'Lier une demande',
    },
    title: 'Demande(s) liées',
    info: {
      code: 'Demande n°',
      send: 'Envoyé le ',
      description: 'Description',
    },
  },
  bilan: {
    title: 'Bilan intervention',
  },
  messages: {
    success: {
      create: 'Ordre de travail technique créé avec succès.',
      update: 'Ordre de travail technique modifié avec succès.',
    },
    error: {
      technicWorkOrdreProduct: 'La société ne contient pas de produit d\'OT technique',
      leastOneProduct: 'Le patrimoine sélectionné doit contenir au moins une face ou un matériel numérique',
      onePatrimoineType: 'Exactement un type de patrimoine peut être renseigné à la fois',
      libelleTache: 'Titre de la tâche',
      libelleDescription: 'Description de la tâche',
    },
    successLieuDeLivraisonCreation: 'Lieu de livraison créé avec succès',
  },
  popUpPrevention: {
    title: 'Sauvegarde de l\'OT technique',
    actionMontage: 'Passer à l\'état "En cours de montage" le patrimoine lié ?',
    actionDemontage: 'Passer à l\'état "En cours de démontage" le patrimoine lié ?',
  },
  otStock: {
    tiersId: 'Lieu de stockage',
    quantite: 'Quantite',
    nomFichierRip: 'Nom du fichier',
    graphisteEnChargeId: 'Graphiste en charge',
  },
  lieuDeLivraison: {
    title: 'Lieu de livraison',
    search: 'Rechercher un lieu de livraison',
    new: 'Créer un nouveau lieu de livraison',
    noResult: 'Aucun résultat',
    autocomplete: {
      search: 'Rechercher',
    },
    informations: {
      commercialName: 'Raison sociale',
      postalAddress: 'Adresse postale',
      addLieuDeLivraison: 'Nouveau lieu de livraison',
      address: 'Adresse',
    },
    actions: {
      revert: 'Annuler',
      add: 'Ajouter',
    },
    validation: {
      nomCommercial: 'La raison sociale est requise',
      adressePostale: 'L\'adresse postale est requise',
    },
  },
};

export const DETAIL_ORDRE_TRAVAIL_TECH = {
  title: 'Détail ordre de travail {code}',
  breadcrumb: {
    liste: 'Ordres de travail',
    detail: 'Détail ordre travail technique',
  },
  popUpMail: {
    title: 'Rédiger votre email',
    inclureOt: 'Inclure l\'OT',
    otObject: 'Ordre de travail {code}',
  },
  actions: {
    enCours: 'En cours',
    enAttente: 'En attente',
    annuler: 'Annuler',
    realise: 'Réaliser',
    planifie: 'Planifier',
    cloture: 'Clôturer',
    aExpedier: 'A expédier',
    expedie: 'Expédié',
    prisEnCharge: 'Prendre en charge',
  },
  onglet: {
    caracterique: 'Caractéristiques',
    patrimoine: 'Patrimoine',
    demande: 'Demande(s) liée(s)',
    bilan: 'Bilan intervention',
    lieuDeLivraison: 'Lieu de livraison',
  },
  caracterique: {
    infoGenerale: {
      title: 'Informations générales',
      dateSouhaite: 'Date souhaitée :',
      datePlanification: 'Date de planification :',
      dateRealisation: 'Date de réalisation :',
      typeIntervention: 'Type d\'intervention :',
      technicien: 'Technicien :',
      montantHT: 'Montant HT :',
      dossierAssocie: 'Dossier associé :',
      description: 'Description : ',
      agence: 'Agence :',
      projet: 'Projet :',
      dateFacture: 'Date facture :',
      codeFacture: 'Code facture :',
      lieuDeStockage: 'Lieu de stockage :',
      campagne: 'Campagne',
      bonExpedition: 'Bon d\'expédition',
      tags: 'Tag(s) :',
    },
    bonStock: {
      title: 'Bon de sortie',
    },
    tache: {
      title: 'Liste des tâches',
      taches: '{tacheRealise} / {tacheTotal} tâche(s)',
      noTache: 'Aucune tâche ajoutée',
    },
    infoCommande: {
      title: 'Informations commande',
      code: 'Code commande :',
      dateCampagne: 'Date de campgane :',
      codeDossier: 'Code dossier :',
      theme: 'Thème :',
      etat: 'Etat :',
      commercial: 'Commercial :',
    },
    campagne: {
      title: 'Campagne {name}',
    },
  },
  patrimoine: {
    noPat: 'Aucun patrimoine sélectionné',
    emplacement: {
      champs: {
        title: 'Emplacement',
        natureSol: 'Nature de sol :',
        codeBarre: 'Code barre :',
        degreDeniveleTerrain: 'Degré de dénivelé du terrain :',
        accesSiteSurRdv: 'Accès au site sur RDV :',
        acces: 'Accès :',
        groupeDhabitation: 'Groupe d\'habitation :',
        numUg: 'N° UG :',
        quartier: 'Quartier :',
      },
    },
    dispositif: {
      title: 'Dispositif : {code}',
      type: 'Type : {type}',
      support: 'Support : {support}',
      Adresse: 'Adresse',
      Etat: 'Etat : {etat}',
      champs: {
        title: 'Dispositif',
        couleurRal: 'Couleur RAL: ',
        restrictionsAffichage: 'Restrictions d\'affichage : ',
        valeurAcquisition: 'Valeur d\'acquisition : ',
        longueur: 'Longueur : ',
        publicitaire: 'Publicitaire : ',
        particularite: 'Particularité : ',
        largeurToit: 'Largeur toit : ',
        eclairable: 'Eclairable : ',
        planRecollement: 'Plan recollement : ',
        cableEdfProx: 'Câble EDF à proximité : ',
        distanceEnMCablesEdf: 'Distance en mètres câbles EDF : ',
        hauteurSousPanneau: 'Hauteur sous panneau : ',
        nacelleNecessaire: 'Nacelle nécessaire : ',
        grueNecessaire: 'Grue nécessaire : ',
        echelleNecessaire: 'Echelle nécessaire : ',
        autreEquipementNecessaire: 'Autre équipement nécessaire : ',
        obstacle: 'Obstacle : ',
        declararionPrealable: 'Déclaration préalable : ',
        fournisseurElectricite: 'Fournisseur éléctricité : ',
        tiersProprietaire: 'Tiers propriétaire : ',
        accessoires: {
          title: 'Liste des accessoires :',
          libelle: 'Accessoire',
          quantite: 'Quantité',
          fournisseur: 'Fournisseur',
        },
      },
    },
    materiel: {
      champs: {
        title: 'Matériel',
        passerelle: 'Passerelle :',
        typeEclairage: 'Type d\'éclairage :',
        longueur: 'Longueur (cm) :',
        largeur: 'Largeur (cm) :',
      },
    },
    face: {
      title: 'Face : {code}',
    },
  },
  demandeLiee: {
    noDemande: 'Aucune demande liée',
  },
  bilan: {
    title: 'Bilan intervention',
  },
  popup: {
    msgAnnulerOt: 'Êtes-vous sûr de vouloir annuler votre ordre de travail ?',
    msgAnnulerOtAvecBon: 'Êtes-vous sûr de vouloir annuler votre ordre de travail et supprimer le bon de sortie ?',
    msgPlanifierOt: 'Êtes-vous sûr de vouloir planifier votre ordre de travail ?',
    msgEncoursOt: 'Êtes-vous sûr de vouloir mettre à l\'état "en cours" votre ordre de travail ?',
    msgEnAttenteOt: 'Êtes-vous sûr de vouloir mettre à l\'état "en attente" votre ordre de travail ?',
    msgRealiserOt: 'Êtes-vous sûr de vouloir réaliser votre ordre de travail ?',
    msgCloturerOt: 'Êtes-vous sûr de vouloir clôturer votre ordre de travail ?',
    msgAExpedierOt: 'Êtes-vous sûr de vouloir mettre l\'état à "à expédier" votre ordre de travail ?',
    msgExpedieOt: 'Êtes-vous sûr de vouloir mettre l\'état à "expédié" votre ordre de travail ?',
    actionIntervationTypeOt: 'Effectuer l\'action de "{ActionInterventionOtType}" sur le patrimoine lié',
    updateDemande: 'Passer à l\'état "Traité" mes demandes liées',
    actionAnnulationImpactEtatDemande: 'Passer à l\'état "Refusé" les demandes liées',
    datePlanification: 'Date de planification',
    dateRealisation: 'Date de réalisation',
  },
  messages: {
    changer: {
      success: 'Etat ordre de travail technique changé avec succès',
    },
    realiser: {
      success: 'Ordre de travail technique realisé avec succès',
    },
    success: {
      otDelete: 'Ordre de travail supprimé avec succès',
      fournisseurUpdate: 'Technicien mis à jour avec succès',
    },
    error: {
      otNeedDatePlanif: 'Pour passer à l\'état "Planifié", l\'OT technique doit avoir une date de planification renseignée',
      otNeedDateRealisation: 'Pour passer à l\'état "Réalisé", l\'OT technique doit avoir une date de réalisée renseignée',
      userIsNotTechnician: 'Vous ne pouvez pas prendre en charge cet/ces OT(s) car vous n\'avez pas le rôle de technicien',
    },
  },
  popUpSuppression: {
    title: 'Etes-vous sûr de vouloir supprimer cet ordre de travail ?',
    monter: 'Passer à l\'état "Monter" le patrimoine lié ?',
    demonter: 'Passer à l\'état "Démonter" le patrimoine lié ?',
  },
  lieuDeLivraison: {
    generalInformations: 'Informations générales',
    raisonSociale: 'Raison sociale:',
    adresse: 'Adresse',
    dept: 'Dept',
  },
  popUpFournisseurTitle: 'Êtes-vous sûr de vouloir prendre en charge cet ordre de travail ?',
};
